module.exports = __webpack_public_path__ + "static/media/bell-school.f0a85d36.svg";